import { Injectable } from '@angular/core';
import * as Raven from 'raven-js';
import { ConfigService } from './config.service';

@Injectable()
export class SentryService {
  constructor(private configService: ConfigService) {}

  setInitialParams() {
    Raven.config('https://be0d5691cb0248d899b13c3785fa38e3@sentry.io/197007', {
      release: this.configService.commitHash,
      shouldSendCallback: () => this.configService.getValue('SENTRY_ENABLED'),
      ignoreErrors: ['Non-Error exception captured']
    }).install();
  }
}
